// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"9d674ae697999457af74","293":"bfcce98b214c1331e210","518":"432dccf210a8e3801230","779":"f0c20df361f2c65fafb4"}[chunkId] + ".js";
};